module.exports = __webpack_public_path__ + "img/lesson_01.b893ae94.jpg";